<div class="verification-dialog-wrapper">
  <!-- Dialog Header -->
  <div class="dialog-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <div class="icon-badge p-2 rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center">
        <mat-icon class="text-primary">fact_check</mat-icon>
      </div>
      <div>
        <h5 class="dialog-title font-weight-bold m-0">Verify Extracted Document Data</h5>
        <p class="dialog-subtitle m-0">
          Review AI-parsed document details and update parameters before saving to database.
        </p>
      </div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <span class="badge badge-dark-pill px-3 py-2 font-weight-600">
        {{ data.parsed_data.document_title || 'Document Summary' }}
      </span>
      <button mat-icon-button class="text-secondary ml-2" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Dialog Body Content -->
  <mat-dialog-content class="dialog-body">
    <!-- Top Summary Banner -->
    <div class="vessel-summary-card p-3 rounded-lg mb-4" *ngIf="summaryHeaderItems.length > 0">
      <div class="row align-items-center">
        <div 
          *ngFor="let item of summaryHeaderItems; let isLast = last" 
          class="col-md-3"
          [class.summary-border]="!isLast"
        >
          <span class="summary-label text-uppercase d-block mb-1 text-truncate" [title]="item.key">
            {{ item.key }}
          </span>
          <span class="summary-val font-weight-bold m-0 d-block text-truncate" [title]="item.value">
            {{ item.value }}
          </span>
        </div>
      </div>
    </div>

    <!-- Metadata Section -->
    <mat-expansion-panel class="dark-panel mat-elevation-z0 mb-4" [expanded]="true" *ngIf="headerKeys.length > 0">
      <mat-expansion-panel-header class="px-3">
        <mat-panel-title>
          <mat-icon class="mr-2 text-info fs-18">tune</mat-icon> Document Header Parameters ({{ headerKeys.length }})
        </mat-panel-title>
      </mat-expansion-panel-header>
      
      <div class="pt-3 pb-2 px-1">
        <div class="row">
          <div class="col-md-4 mb-3" *ngFor="let key of headerKeys">
            <label class="field-label text-truncate d-block" [title]="key">{{ key }}</label>
            <input 
              type="text" 
              class="form-control custom-dark-input" 
              [(ngModel)]="parsedHeaders[key]" 
              placeholder="Not specified"
            />
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- Table Section with Horizontal Scrolling -->
    <div *ngFor="let table of parsedTables; let tIdx = index" class="dark-card mb-4 shadow-sm">
      <div class="card-header-dark d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <mat-icon class="text-primary mr-2 fs-18">table_chart</mat-icon>
          <span class="font-weight-bold text-white small text-uppercase">
            {{ table.table_title || 'Extracted Records ' + (tIdx + 1) }}
          </span>
          <span class="badge badge-dark-pill ml-2 font-weight-normal px-2">
            {{ table.rows?.length || 0 }} Entries
          </span>
        </div>
        <button type="button" class="btn btn-sm btn-dark-outline d-flex align-items-center" (click)="addRow(table)">
          <mat-icon class="mr-1 fs-16 align-middle">add</mat-icon> Add Record
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead>
            <tr>
              <th *ngFor="let col of table.columns" class="table-header-cell">{{ col }}</th>
              <th class="table-header-cell text-center" style="width: 60px;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of table.rows; let rIdx = index" class="table-row">
              <td *ngFor="let col of table.columns" class="py-2 px-2">
                <input 
                  type="text" 
                  class="form-control form-control-sm dark-table-input" 
                  [(ngModel)]="row[col]" 
                  placeholder="--"
                />
              </td>
              <td class="text-center py-2 px-2">
                <button mat-icon-button (click)="removeRow(table, rIdx)" matTooltip="Remove row">
                  <mat-icon class="btn-delete-icon fs-18">delete_outline</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Dialog Footer -->
  <div class="dialog-footer d-flex align-items-center justify-content-between">
    <span class="text-secondary small">
      <mat-icon class="align-middle fs-16 text-info mr-1">info</mat-icon> Verified data will update directly in vessel database records.
    </span>
    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-dark-outline font-weight-600 mr-2" (click)="onCancel()">Cancel</button>
      <button class="btn btn-indigo-action font-weight-600 shadow d-flex align-items-center" [disabled]="submitting" (click)="onConfirm()">
        <span *ngIf="submitting" class="spinner-border spinner-border-sm mr-2"></span>
        <mat-icon class="mr-1 fs-18" *ngIf="!submitting">check_circle</mat-icon>
        Confirm & Save
      </button>
    </div>
  </div>
</div>